// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list[data-v-9c49b236]{width:580px}.v-list-item[data-v-9c49b236]{min-height:40px !important}.text-input-value[data-v-9c49b236]{white-space:normal}.cursor-pointer[data-v-9c49b236]:hover{color:#007dd6}", ""]);
// Exports
module.exports = exports;
